export const  GeneroPersonaEnum  = Object.freeze({
    FEMENINO: 1,
    MASCULINO: 2,
})